import { c as _c } from "react/compiler-runtime";
// import { PerksAside } from './PerksAside'
import { AppLayout } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { PerksContextProvider } from '@src/components/sco/Perks/Layout/PerksContext';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useAppContextStore } from '@src/contexts/AppContextStore';
import Link, { LinkProps } from 'next/link';
import { usePathname } from 'next/navigation';
import React, { ReactNode, useMemo } from 'react';
export const PerksLayout = (props: {
  navPanel?: ReactNode;
  mainPanel?: ReactNode;
  asidePanel?: ReactNode;
}) => {
  const pathname = usePathname();
  const {
    contextStore
  } = useAppContextStore();
  const [asidePanelIsOpen, setAsidePanelIsOpen] = React.useState(false);
  const panels: AppLayoutPanelProps[] = useMemo(() => [
  // {
  //   id: 'perks-nav',
  //   useDrawerBreakpoints: { base: true, md: false },
  //   isResizable: true,
  //   resizeHandlePosition: 'right',
  //   defaultWidth: 280,
  //   minWidth: 200,
  //   maxWidth: 400,
  //   children: props.navPanel ? props.navPanel : <PerksNav />,
  //   isPanelOpen: true,
  //   isDrawerOpen: false,
  //   containerProps: {
  //     bgColor: 'sidebarBackground',
  //     boxShadow: '4px 0px 10px 0px rgba(0, 0, 0, 0.25)',
  //   },
  // },
  {
    id: 'perks-main',
    children: props.mainPanel,
    isPanelOpen: true,
    isDrawerOpen: true
  }
  // {
  //   id: 'perks-aside',
  //   useDrawerBreakpoints: { base: true, lg: false },
  //   isResizable: true,
  //   resizeHandlePosition: 'left',
  //   drawerPlacement: 'right',
  //   defaultWidth: 300,
  //   minWidth: 300,
  //   maxWidth: 600,
  //   children: props.asidePanel || <PerksAside />,
  //   isPanelOpen: asidePanelIsOpen,
  //   onPanelClose: () => {
  //     setAsidePanelIsOpen(false)
  //   },
  //   isDrawerOpen: false,
  //   containerProps: {
  //     bgColor: 'blackAlpha.500',
  //     borderLeft: '1px solid',
  //     borderLeftColor: 'whiteAlpha.100',
  //   },
  // },
  ], [pathname]);
  return <PerksContextProvider {...contextStore.getNamespace('PerksContext')}>
      <AppLayout header={<ScoSiteNavBar />} id={'perks-layout'} panels={panels} />
    </PerksContextProvider>;
};
const NextLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Link ref={ref} {...props} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export const PerksPage = Component => {
  Component.getLayout = (page: React.ReactElement) => {
    return <PerksLayout mainPanel={page} />;
  };
  return Component;
};